(function () {
  const FORM_SELECTOR = '[data-filter-form]';
  const INPUT_SELECTOR = '[data-filter-input]';
  const RESULTS_SELECTOR =
    '[data-results-container], .collection__products-container, #root';

  function serialize(form) {
    return new URLSearchParams(new FormData(form)).toString();
  }

  async function applyFilters(form, pushState = true) {
    const params = serialize(form);
    const sectionId = 'main-collection-product-grid'; // ⚠️ change if needed
    const url = `${form.action}?${params}&section_id=${sectionId}`;

    try {
      const res = await fetch(url, {
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });

      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');

      const newResults = doc.querySelector(RESULTS_SELECTOR);
      const currentResults = document.querySelector(RESULTS_SELECTOR);

      if (!newResults || !currentResults) return;

      currentResults.innerHTML = newResults.innerHTML;

      if (pushState) {
        history.pushState({}, '', `${form.action}?${params}`);
      }
    } catch (err) {
      console.error('Collection filter failed', err);
      form.submit();
    }
  }

  document.addEventListener('change', function (e) {
    const input = e.target.closest(INPUT_SELECTOR);
    if (!input) return;

    const form = input.closest(FORM_SELECTOR);
    if (!form) return;

    e.preventDefault();
    applyFilters(form);
  });

  window.addEventListener('popstate', function () {
    const form = document.querySelector(FORM_SELECTOR);
    if (form) applyFilters(form, false);
  });
})();
